import { ReactNode } from "react";
import CustomPricingEmbed from "../custom-renderers/heavy-truck/CustomPricingEmbed";
import SystemNotificationsEmbed from "../custom-renderers/system-notifications/SystemNotificationsEmbed";

type SetupRenderer = () => ReactNode;

export const SETUP_RENDERERS: Record<string, SetupRenderer> = {
  CustomPricing: () => <CustomPricingEmbed />,
  SystemNotifications: () => <SystemNotificationsEmbed />,
};
